import { GroupZoomScheduleWeekDay } from 'core/graphql';

/** A `{ value, label }` time option for the schedule slot picker. */
export interface IScheduleTimeOption {
  value: string;
  label: string;
}

/**
 * 48 half-hour slots `00:00 … 23:30`. `value` is a `HH:MM:00` `Time` scalar
 * (what the `runTime` GraphQL field expects), `label` is the `HH:MM` shown.
 */
export const SCHEDULE_TIME_OPTIONS: IScheduleTimeOption[] = Array.from(
  { length: 48 },
  (_, index) => {
    const hh = String(Math.floor(index / 2)).padStart(2, '0');
    const mm = index % 2 === 0 ? '00' : '30';
    return { value: `${hh}:${mm}:00`, label: `${hh}:${mm}` };
  },
);

/** `GroupZoomScheduleWeekDay.A_3` → `3` (0 = Monday … 6 = Sunday). */
export const weekDayToInt = (weekDay: GroupZoomScheduleWeekDay): number =>
  Number(String(weekDay).replace('A_', ''));

/** Normalises a `Time` scalar (`HH:MM:SS`) to `HH:MM` for display/comparison. */
export const formatRunTime = (runTime: string): string => runTime.slice(0, 5);

/** Stable key for a `(weekDay, time)` slot — used for conflict detection. */
export const slotKey = (weekDay: number, runTime: string): string =>
  `${weekDay}-${formatRunTime(runTime)}`;
